import { Button, Card, CardBody, CardImage, Stack, Typography } from "@octopus-energy/coral/atoms"
import { type ISbStoryData } from "@storyblok/react"
import { getStoryHref } from "@/features/storyblok/utils/getStoryHref"

type BlogPostFeaturedProps = {
    story: ISbStoryData
}

export function BlogPostFeatured({ story }: BlogPostFeaturedProps) {
    return (
        <Card padding="none">
            <CardImage
                height={400}
                src={story.content.image?.filename}
            />
            <CardBody padding="medium">
                <Stack
                    flexDirection="column"
                    alignItems="flex-start"
                >
                    <Typography
                        attributes={{ "data-testid": `post-title-${story.uuid}` }}
                        textStyle="h2"
                    >
                        {story.content.title}
                    </Typography>
                    <Button
                        size="small"
                        href={getStoryHref(story)}
                        fullWidth={{ base: true, md: false }}
                    >
                        En savoir plus
                    </Button>
                </Stack>
            </CardBody>
        </Card>
    )
}
